import { HttpClient } from '@angular/common/http';import { inject, Injectable, signal } from '@angular/core';
import { BaseSiteService, GlobalMessageService, GlobalMessageType, OccEndpointsService } from '@spartacus/core';
import { BaseService } from './base.service';
import { BehaviorSubject } from "rxjs";
import * as _ from 'lodash';
import { first, map } from "rxjs/operators";
import { NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { OtpModalComponent } from "../modules/otp-modal/otp-modal/otp-modal.component";
import { FormName } from '../config/ga.config';

@Injectable({
  providedIn: 'root'
})
export class MultiFactorAuthService {
  private readonly modalService = inject(NgbModal);
  private readonly baseService = inject(BaseService);
  private readonly http = inject(HttpClient);
  private readonly occEndPoint = inject(OccEndpointsService);
  private readonly baseSiteService = inject(BaseSiteService);
  private readonly messageService = inject(GlobalMessageService);

  baseSiteId: string;
  multiFactorAuthResult: BehaviorSubject<any>;

  constructor() {
    this.baseSiteService.getActive()
      .pipe(
        first(Boolean)
      )
      .subscribe(res => this.baseSiteId = res);
  }


  public requestNewOTP(params?) {
    const url = !params ? '/new' : `/new?method=${params}`;
    return this.http.get(this.occEndPoint.buildUrl(url));
  }

  validateOTP(otp, type) {
    const params = { otp: otp };

    return this.http.post(this.occEndPoint.buildUrl(`/validate?otp=${otp}&method=${type}`),
      params, { responseType: 'text' });
  }

  /**
   * Challenges a just-entered mobile number by SMS right away: no /methods call and no method choice. The
   * result is emitted on multiFactorAuthResult: status true once the code is valid, status false when the
   * modal is closed, which the caller must treat as a cancellation of the change.
   */
  verifyNewMobile(processType: string): void {
    this.multiFactorAuthResult = new BehaviorSubject<any>(null);
    this.modalTrigger(
      { gaProcess: `${ processType }-${ FormName.MOBILE }` },
      { process: FormName.MOBILE, directMethod: 'mobile', methods: [] }
    );
  }

  getMethodsOTP(process?: any) {
    return this.http.get(this.occEndPoint.buildUrl('/methods'))
      .pipe(
        map(x => {
      const method = _.filter(x, { name: process});
      const verify = _.filter(x, otp => otp.active && otp.value !== null);
      //TODO remove if not needed anymore
     /* const verify = _.filter(x, { verified: true})?.length
        ? _.filter(x, otp => otp.verified == true && otp.value !== null)
        : _.filter(x, otp => otp.enabled == true && otp.value !== null)*/
      x = (process == 'e-mail' || process == 'mobile') ? (method ? method : verify) : verify;
      const active = _.filter(x, { enabled: true });
      return active || null ;
    })
      );
  }

  modalTrigger(loc, content, error?) {
    const modalRef = this.modalService.open(OtpModalComponent, {
      windowClass: this.baseSiteId + ' sanofi-otpModal',
    })

    modalRef.componentInstance.otpChoices = signal(!!error ? loc : {...loc,...content});

    modalRef.dismissed
      .pipe(
        first()
      )
      .subscribe(() => this.multiFactorAuthResult.next({status: false}));

    modalRef.componentInstance.isLimitReached = signal(error || false)
    modalRef.result.then((res) => {
      if (res.status == 'success') this.multiFactorAuthResult.next(
        res.process
          ? { process: res.process, status: true }
          : { status: true }
      )});
  }

  multiFactorAuth(triggerLocation: string, params?: any, process?: FormName): void {
    this.multiFactorAuthResult = new BehaviorSubject<any>(null);
    const loc = { gaProcess: triggerLocation };
    this.getMethodsOTP(params).subscribe({
      next: (res) => {
      if (res?.length) {
        const content = {
          process,
          processCount: res?.length,
          methods: res
        };
        !_.isEmpty(_.filter(res, { limited: false })) || (params == 'mobile' && res[0]?.name == params)
          ? this.modalTrigger(loc, content)
          : this.modalTrigger(loc, null, true);
      } else {
        console.log('res', res, process)
        this.multiFactorAuthResult.next({ process, status: true });
      }
    },
    error: (error) => {
      this.modalTrigger(loc, null, true);
      this.messageService.add(error?.error?.errors[0]?.message, GlobalMessageType.MSG_TYPE_ERROR)
      this.multiFactorAuthResult.next({ error: error?.error?.errors[0]?.message });
    }
    });
  }
}
